export const START_DATE = new Date();
